// Lightweight cache for player search results to avoid repeated network calls.
// Keys are derived from team + names tokens to ensure consistent reuse.

const STORAGE_KEY = 'playerCache.v1';

function normalizeToken(t) {
  return String(t || '').trim().toLowerCase();
}

function makeKey({ team, names }) {
  const teamPart = normalizeToken(team);
  const arr = Array.isArray(names) ? names.map(normalizeToken).filter(Boolean) : [];
  // Preserve order for better specificity, but remove duplicates
  const seen = new Set();
  const ordered = [];
  for (const n of arr) { if (!seen.has(n)) { seen.add(n); ordered.push(n); } }
  return `${teamPart}|${ordered.join('+')}`;
}

function loadInitial() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const obj = JSON.parse(raw);
    if (obj && typeof obj === 'object') return obj;
  } catch (_) {}
  return {};
}

const mem = loadInitial();
let dirty = false;
let saveTimer = null;

function scheduleSave() {
  if (saveTimer) return;
  saveTimer = setTimeout(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(mem));
    } catch (_) {}
    saveTimer = null;
  }, 250);
}

export function getCachedPlayers(queries) {
  // queries: [{ team, names }]
  return (queries || []).map((q) => {
    const key = makeKey({ team: q.team, names: q.names });
    return mem[key] || null;
  });
}

export function setCachedPlayers(queries, results) {
  // Set cache entries for queries -> result
  let wrote = false;
  (queries || []).forEach((q, idx) => {
    const res = (results || [])[idx];
    if (!res) return;
    const key = makeKey({ team: q.team, names: q.names });
    // Store minimal player info used by UI
    mem[key] = {
      id: res.id,
      names: Array.isArray(res.names) ? res.names : [],
      display_name: res.display_name || (Array.isArray(res.names) ? res.names[0] : undefined),
      team: res.team,
      image_url: res.image_url,
    };
    wrote = true;
  });
  if (wrote) scheduleSave();
}

export function clearPlayerCache() {
  try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}
  for (const k of Object.keys(mem)) delete mem[k];
}

